import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.productAttribute';

const translations = {
    'productAttribute': 'Termékparaméterek',
    'edit.title': 'Termékparaméter szerkesztése',
    'create.title': 'Új termékparaméter',
    'productAttributeCreate': 'Új termékparaméter',
    'id.title': 'ID',
    'name.title': 'Név',
    'code.title': 'Kód',
    'code.hint': 'Ne használj ékezetet és különleges karaktert!',
    'filterable.title': 'Szűrhető',
    'is_active.title': 'Aktív',
    'type.title': 'Típus',
    'type.hint': 'Többszörös: egy termékhez több változat is tartozhat. Egyszeres: Egy termékhez csak egy változat tartozhat',
    'options.title': 'Opciók',

    'delete.label': 'Törlés',

    'label.title': 'Címke',
    'is_default.title': 'Alapértelmezett',

    'optionType.SIMPLE': 'Egyszeres',
    'optionType.MULTIPLE': 'Többszörös',

    'newOption': 'Új opció',

    'notification.move.success': 'Sikeres módosítás',
    'notification.delete.success': 'Sikeres törlés',
    'notification.error': 'Hiba történt',

};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/ProductAttribute/lang/hu.ts